import { createReducer, on } from '@ngrx/store';
import {
  createPathologySuccess,
  deletePathologySuccess,
  readPathologies,
  readPathologiesFailure,
  readPathologiesSuccess,
  restorePathologySuccess,
  updateClientSuccess,
} from './pathology.actions';
import { PathologyDto } from '@shared/dto';
import { upsertInArray } from '@shared/utils/array.utils';
import { logout } from '@auth/store/auth.actions';
import { hydrateSuccess } from '@store/storage.actions';
import { State } from '@store/state.interface';

export const PATHOLOGY_FEATURE_KEY = 'pathology';

export interface PathologyState extends State<PathologyDto> {}

export const initialState: PathologyState = {
  data: null,
  detail: null,
  total: 0,
  query: null,
  loading: false,
  error: null,
};

export const pathologyReducer = createReducer(
  initialState,
  on(readPathologies, (state) => ({ ...state, loading: true, error: null })),
  on(readPathologiesSuccess, (state, { data, total }) => ({ ...state, data, total, loading: false })),
  on(readPathologiesFailure, (state, { error }) => ({ ...state, loading: false, error })),
  on(createPathologySuccess, (state, { pathology }) => ({
    ...state,
    data: upsertInArray(state.data, pathology) as PathologyDto[],
  })),
  on(updateClientSuccess, (state, { pathology }) => ({
    ...state,
    data: upsertInArray(state.data, pathology as PathologyDto) as PathologyDto[],
  })),
  on(deletePathologySuccess, (state, { pathology }) => ({
    ...state,
    data: upsertInArray(state.data, pathology) as PathologyDto[],
  })),
  on(restorePathologySuccess, (state, { pathology }) => ({
    ...state,
    data: upsertInArray(state.data, pathology) as PathologyDto[],
  })),
  on(hydrateSuccess, (state, { state: persisted }) =>
    persisted.pathology ? { ...state, ...persisted.pathology } : state
  ),
  on(logout, () => initialState),
);
